import { servicesVersion } from "typescript";

export let localStorageConstants = {
    app_path: "app_path",
    company_name: "company_name",
    Region: "Region",
    server_url: "server_url",
    chart_iq_url: "chart_iq_url",
    chart_trading_url: "chart_trading_url",
    signalr_url: "signalr_url",
    signalr_hub: "signalr_hub",
    theme: "theme",
    isTickerVisible: "isTickerVisible",
    last_Work_day: "last_Work_day",
    Foreign_Market: "Foreign_Market",
    PortfolioProvider: "PortfolioProvider",
    EnableTags: "EnableTags",
    EnableIPOQuickSell: "EnableIPOQuickSell",
    EnableSymbolFullName: "EnableSymbolFullName",
    EnableMarketWatchCache: "EnableMarketWatchCache",
    RegulaUrl: "RegulaUrl",
    FullTradeLimit: "FullTradeLimit",
    RealTimePortfolioUpdate: "RealTimePortfolioUpdate",
    PortfoliRefreshDelay: "PortfoliRefreshDelay",
    Use_New_Chart: "Use_New_Chart"
};

export let serverURL = "";
export let signalrURL = "";
export let signalrHub = "";
export let domainURL = "";
export let baseURL = "";

//Login/logoff
export let userAuthintications = "UserAuthintications";
export let UserAuthinticationAdvance = baseURL + "UserAuthinticationAdvance"; //new api
export let ForGotUsername = baseURL + "ForGotUsername"; //new api
export let UserAuthinticationIPOQuickSell = baseURL + "UserAuthinticationIPOQuickSell"; //new api
export let ResetUserNameAdvance = baseURL + "ResetUserNameAdvance"; //new api
export let ResetPasswordAdvance = baseURL + "ResetPasswordAdvance"; //new api

export let logOff = "UsersLogOff";
export let registrationsOTP = "RegistrationsOTP";
export let changesPassword = "ChangesPassword";
export let renewSubscriptionUser = "";

//profile api
export let profileBaseUrl = "";
export let profileBaseUrlPart2 = "";
export let getProfiles = "";
export let getCompaniesLookups = "";

export let GetUserAccounts = "";
export let addMarketWatchProfileSymbol = "";
export let addMarketWatchProfileName = "";
export let deleteMarketWatchProfile = "";
export let HeartBeat = "";
export let RenewUserSesssion = "";
export let deleteMarketWatchProfileSymbol = ""; //{ProfileID}/{Symbol}/{WebCode}
export let DeleteMarketWatchProfileAllSymbols = ""; //{ProfileID}/{Symbol}/{WebCode}
export let GetAvgIndexes = "";
export let getMarketByProfileDefault = "GetMarketWatchByProfileID/1/";
export let getMarketByProfile = "GetMarketWatchByProfileID/";
export let GetMarketWatchCacheDataByProfileID = "GetMarketWatchCacheDataByProfileID/";
export let GetMarketWatchByProfileIDAndSymbol = "GetMarketWatchByProfileIDAndSymbol/";
export let getExchangeSummary = "";
export let getIndexesSummary = "GetMarketIndiciesSecound/";
export let getAllMarketNews = "GetAllMarketNews/";
export let GetUSCompaniesResults = "";
export let CheckIfUSSymbolExist = "";
export let AddUSTOCompaniesLookups = "";

export let addMarketWatchProfileSymbolCache = "";
export let DeleteMarketWatchProfileAllSymbolsCache = "";
export let DeleteMarketWatchProfileSymbolCache = "";

export let GetCryptoCompaniesResults = "";
export let CheckIfCryptoSymbolExist = "";
export let AddCryptoSymbolToCompaniesList = "";

export let TraceInfoPost = "";


export let GetMarketIndicies = "";

export let getLookups = ""; //+ localStorage.getItem("WebCode") + '?' + Math.random()
export let getRiskManagement = "";
export let GetRiskManagment = "";
export let GetRiskManagmentCash = "";
export let GetActiveIPOList = "";
export let GetIPOCategories = "";
export let GetIPOApplicationList = "";
export let GetIPOBalanceAndNotes = "";
export let FindIPOCharacteristics = "";
export let ValidationAndAmountCalculation = "";
export let CreateIpoApplication  = "";
export let calculatesShares = "";
export let addBasketOrderDetails = "";
export let modifyBasketOrderDetails = "";

export let addOrder = "";
export let addOrdersRealTime = "";
export let modifyOrderRealTime = "";
export let cancelOrderRealTime = "";

//Workspace
export let getProfilesByUserId = ""; //+ localStorage.getItem("WebCode");

export let GetSettingWorkSpaceByUserID = ""; //+ localStorage.getItem("WebCode");

export let addProfile = "";
export let UpdateNotificationVascoDetails = "";
export let CheckApproveNotificationVasco = "";
export let CheckLoginApproval = "";
export let updateProfile = "";
export let UpdateUserProfileSettings = "";
export let UpdatePreferredLangAccount = "";
export let reSendUserToken = "";
export let deleteProfile = "";

export let getPasswordPolicy = "";

/* Account Summary */
export let getAccSummary = "";
export let getExpectedProfitLoss = ""; //portfolio api
export let GetPortfolioAndAccSum = ""; //portfolio api and account Summary
export let getTransactionSummary = "";

//statement
export let getStatmentOfAccount = "";
export let getGroupByOrderStatmentOfAccount = "";
export let getGroupedStatmentOfAccount = "";
export let getCashFlowStatements = "";
export let sendDocumentByEmail = "";

export let getTradeConfirmation = "";
export let TradeConfirmationReport = "";
export let getBankTransferInfo = ""; //deprecated
export let getAccountTransferInfo = "";
export let getBalanceBreakdown = "";
export let transferAmountSec = "";
export let submitCrmRequestRamz = "";
export let submitCrmRequestRamz2 = "";
export let getBankIBAN = "";
export let AddBankIBAN = "";
export let CancelB2bRequest = "";
export let CancelEquityTransferRequest = "";
export let checkIBAN = "";
export let AllTransfersReq = "";
export let GetTransferReqPenddingShares = "";

export let getAllPushNotificationsByUser = "";
export let getAllPushNotificationsFromFirebase = "";
export let updateReadPushNotificationsFlag = "";
export let getHistorySymbolData = "";
export let getAlerts = "";
export let addAlert = "";
export let deleteAlertByAlertID = "";
export let getConditionalByUsr = "";
export let GetBracketOrder = "";
export let deleteConditionalByID = "";
export let addConditionalOrder = "";
export let getDFN_StockData = "";

export let getChatWebBRKLookup = "";
export let getLastChatConversion = "";
export let GetShareTransferLogGrouped = "";
export let GetShareTransferLogWithDetails = "";
export let GetShareTransferLogDetails = "";
export let GetNextRequestID = "";
export let SubmitShareTransferReq = "";

export let SubmitEquityTransferReq = "";
export let AddEquityTrans = "";
export let GetAccountTransferInfo = "";
export let GetExpectedProfitLossSec = "";
export let SubmitMCDShareTransfer = "";
export let EstimateOrderCharges = "";
export let SubmitMCDCashTransfer = "";
export let GetUserPermissionsByGroupID = "";

//Report Service
export let GetAccountSummaryReport = "";
export let GetExpectedPortfolioReport = "";
export let GetProfitLossTransactionReport = "";
export let GetTradesConfirmationReport = "";
export let GetHoldingStatementReport = "";
export let DownloadHoldingStatement = "";

export let GetUSSymbolNews = "";
export let CheckUpdateIdValidity = "";
export let UpdateIdValidity = "";
export let UploadClientDocuments = "";
export let GetRequiredUserDocuments2 = "";
export let GetExpiredAttachment = "";

export let GetContactInfo = "";
export let GetCashDepURL = "";
export let GetDeviceConfigs = "";
export let TechnicalIndicator = "";
export let BasketOrederURL = "";
export let DeleteBasketOrder = "";
export let UpdateRejectReasonBasketOrder = "";
export let CustodiansByClientID = "";
export let GetDailyReports = "";
export let TransferAmount = "";
export let MainCrmRequest = "";
export let SendCallBankTransfareRequest = "";
export let GetIPOLink = "";
export let UpdateTermsAndConditionsVersion = "";
export let GetTermsAndConditionsText = "";
export let GetChartIntraDayData = ""; // mustafa
export let GetSymbolsTrades = "";
export let GetSubscriptionPlans = ""; // mustafa
export let GetSubscribedPlans = ""; // mustafa
export let AddSubscription = ""; // mustafa
export let GetCurrencyConversion = ""; // mustafa
export let CashTransfer = "";
export let GetMCDShareTransferList   = "";
export let GetMarketPerformanceData = "";
export let GetMDBlockTrade = "";
export let GetMDSectorRanking = "";
export let GetMDMarketBreadth = "";
export let GetMDInvestorsDistribution = "";
export let GetMDInvestorsDistributionDataChart = "";

// KYC services
export let GetCountriesLookup = "";
export let GetOnboardingLookUP = "";
export let GetNationalityLookup = "";
export let GetBankAccDetails = "";
export let AMLSib = "";
export let CreateADXNin = "";
export let CreateDFMNin = "";
export let OTPSend = "";
export let LoginByUsrKYC = "";
export let GetOnboardingData = "";
export let GetSourceOfIncome = "";
export let GetAnnualIncome = "";
export let GetInvesObjective = "";
export let GetRiskClassification = "";
export let GetCities = "";
export let GetKYCCibc = "";
export let GetCompaniesKYC = "";
export let InsertAttachments = "";
export let ICAPScanningFile = "";

//

export let GetNewCustodiansByClientID = "";
export let GetTradeSummary = "";
export let GetTodayTrade = "";
export let GetHistoryOrders = "";
export let GetHistoricalTradesList = "";
export let GetMCDCashTransfer = "";
export let getEGYPTSectors = "";
export let GetMarketWatchBySectorID = "";
//function to update basic exported values, since exported Let variables are only modified in its module
export function updateUrls(server_url, signalr_url, signalr_hub) {
    serverURL = server_url;
    signalrURL = signalr_url;
    signalrHub = signalr_hub;
    domainURL = server_url;

    baseURL = server_url + "GeneralWServices/";
    UserAuthinticationAdvance = baseURL + "UserAuthinticationAdvance"; //new api
    ForGotUsername = baseURL + "ForgotUsername"; //new api
    UserAuthinticationIPOQuickSell = baseURL + "UserAuthinticationIPOQuickSell"; //new api
    ResetUserNameAdvance = baseURL + "ResetUserNameAdvance"; //new api
    ResetPasswordAdvance = baseURL + "ResetPasswordAdvance"; //new api
    getCompaniesLookups = baseURL + "GetCompaniesLookups/";
    CheckIfUSSymbolExist = baseURL + "CheckIfUSSymbolExist/";
    AddUSTOCompaniesLookups = baseURL + "AddUSTOCompaniesLookups/";
    CheckIfCryptoSymbolExist = baseURL + "CheckIfCryptoSymbolExist/";
    AddCryptoSymbolToCompaniesList = baseURL + "AddCryptoSymbolToCompaniesList/";

    TraceInfoPost = baseURL + "TraceInfoPost";

    HeartBeat = baseURL + "HeartBeat/";
    RenewUserSesssion = baseURL + "RenewUserSesssion/";

    profileBaseUrl = domainURL + "MarektWServices/";
    profileBaseUrlPart2 = domainURL + "RealTimeWServices/";
    getProfiles = profileBaseUrl + "GetAllProfilesLookupsByUSerCode/";
    addMarketWatchProfileSymbol = profileBaseUrl + "AddMarketWatchProfileSymbol/";
    addMarketWatchProfileName = profileBaseUrl + "AddMarketWatchProfileName/";
    deleteMarketWatchProfile = profileBaseUrl + "DeleteMarketWatchProfile/";
    deleteMarketWatchProfileSymbol = profileBaseUrl + "DeleteMarketWatchProfileSymbol/"; //{ProfileID}/{Symbol}/{WebCode}
    DeleteMarketWatchProfileAllSymbols = profileBaseUrl + "DeleteMarketWatchProfileAllSymbols"; //{ProfileID}/{Symbol}/{WebCode}

    addMarketWatchProfileSymbolCache = profileBaseUrlPart2 + "AddMarketWatchProfileSymbolCache/";
    DeleteMarketWatchProfileSymbolCache = profileBaseUrlPart2 + "DeleteMarketWatchProfileSymbolCache/";
    DeleteMarketWatchProfileAllSymbolsCache = profileBaseUrlPart2 + "DeleteMarketWatchProfileAllSymbolsCache"; //{ProfileID}/{Symbol}/{WebCode}
    GetMarketWatchCacheDataByProfileID = "GetMarketWatchCacheDataByProfileID/";


    getMarketByProfileDefault = "GetMarketWatchByProfileID/1/";
    getMarketByProfile = "GetMarketWatchByProfileID/";
    GetMarketWatchByProfileIDAndSymbol = "GetMarketWatchByProfileIDAndSymbol/";
    getAllMarketNews = "GetAllMarketNews/";

    getExchangeSummary = domainURL + "MarektWServices/GetExchangeSummary/";
    getIndexesSummary = domainURL + "MarektWServices/GetMarketIndiciesSecound/";
    GetMarketIndicies = domainURL + "MarektWServices/GetMarketIndicies/";
    GetAvgIndexes = domainURL + "MarektWServices/GetAvgIndexes/";

    getRiskManagement = domainURL + "TradingWServices/GetRsikManagment/";
    GetRiskManagment = domainURL + "TradingWServices/GetRiskManagment";
    GetRiskManagmentCash = domainURL + "TradingWServices/GetRsikManagmentCache";
    calculatesShares = domainURL + "TradingWServices/CalculatesShares/";
    addBasketOrderDetails = domainURL + "TradingWServices/AddBasketOrderDetails";
    modifyBasketOrderDetails = domainURL + "TradingWServices/ModifyBasketOrderDetails";
    addOrder = domainURL + "TradingWServices/AddOrder";

    addOrdersRealTime = domainURL + "RealTimeWServices/AddOrders";
    modifyOrderRealTime = domainURL + "RealTimeWServices/ModifyOrders";
    cancelOrderRealTime = domainURL + "RealTimeWServices/CancelOrder";

    GetUserAccounts = domainURL + "GeneralWServices/GetUserAccounts/";
    getLookups = domainURL + "GeneralWServices/getlookups/"; //+ localStorage.getItem("WebCode") + '?' + Math.random()
    getProfilesByUserId = domainURL + "GeneralWServices/GetProfilesLookupByUserID/"; //+ localStorage.getItem("WebCode");
    GetSettingWorkSpaceByUserID = domainURL + "GeneralWServices/GetSettingWorkSpaceByUserID/"; //+ localStorage.getItem("WebCode");
    addProfile = domainURL + "GeneralWServices/AddProfile";
    UpdateNotificationVascoDetails = domainURL + "GeneralWServices/UpdateNotificationVascoDetails";
    CheckApproveNotificationVasco = domainURL + "GeneralWServices/CheckApproveNotification";
    CheckLoginApproval = domainURL + "GeneralWServices/CheckLoginApproval";
    updateProfile = domainURL + "GeneralWServices/UpdateProfile";

    UpdateUserProfileSettings = domainURL + "GeneralWServices/UpdateUserProfileSettings";
    UpdatePreferredLangAccount = domainURL + "GeneralWServices/UpdatePreferredLang/";
    reSendUserToken = domainURL + "GeneralWServices/reSendUserToken/";
    deleteProfile = domainURL + "GeneralWServices/DeleteProfile";
    getPasswordPolicy = domainURL + "GeneralWServices/GetPasswordPolicy/";
    GetUserPermissionsByGroupID = domainURL + "GeneralWServices/GetUserPermissionsByGroupID/"; //{GROUPCODE}/{WEBCODE}
    CheckUpdateIdValidity = domainURL + "GeneralWServices/CheckUpdateIdValidity/";
    UpdateIdValidity = domainURL + "GeneralWServices/UpdateIdValidity3";
    UploadClientDocuments = domainURL + "GeneralWServices/UploadClientDocuments";
    GetRequiredUserDocuments2 = domainURL + "GeneralWServices/GetRequiredUserDocuments2";
    GetExpiredAttachment = domainURL + "GeneralWServices/GetExpiredAttachment";
    ICAPScanningFile = domainURL + "GeneralWServices/ICAPScanningFile";

    getAccSummary = domainURL + "FinancialWServices/GetAccSummary/";
    getExpectedProfitLoss = domainURL + "FinancialWServices/GetExpectedProfitLoss/"; //portfolio api
    GetPortfolioAndAccSum = domainURL + "FinancialWServices/GetPortfolioAndAccSum/"; //portfolio api
    getStatmentOfAccount = domainURL + "FinancialWServices/GetStatmentOfAccount/";
    getGroupByOrderStatmentOfAccount = domainURL + "FinancialWServices/GetGroupByOrderStatmentOfAccount/";
    getGroupedStatmentOfAccount = domainURL + "FinancialWServices/GetGroupedStatmentOfAccount/";
    getCashFlowStatements = domainURL + "FinancialWServices/GetCashFlowStatements/";
    getTradeConfirmation = domainURL + "FinancialWServices/GetTradesConfirmation/";
    TradeConfirmationReport = domainURL + "FinancialWServices/TradeConfirmationReport/";
    getBankTransferInfo = domainURL + "FinancialWServices/GetBankTransferInfo/";
    getAccountTransferInfo = domainURL + "FinancialWServices/GetAccountTransferInfo";
    getBalanceBreakdown = domainURL + "FinancialWServices/GetBalanceBreakDown/";
    transferAmountSec = domainURL + "FinancialWServices/TransferAmountSec";
    submitCrmRequestRamz = domainURL + "FinancialWServices/SubmitCrmRequestRamz";
    submitCrmRequestRamz2 = domainURL + "FinancialWServices/submitCrmRequestRamz2";
    sendDocumentByEmail = domainURL + "FinancialWServices/SendDocumentByEmails/";
    renewSubscriptionUser = domainURL + "FinancialWServices/RenewSubscriptionUser/";
    getTransactionSummary = domainURL + "FinancialWServices/getTransactionSummary/";
    getBankIBAN = domainURL + "FinancialWServices/GetBankIBAN/";
    AddBankIBAN = domainURL + "FinancialWServices/AddBankIBAN";
    CancelEquityTransferRequest = domainURL + "FinancialWServices/CancelEquityTransferRequest";
    CancelB2bRequest = domainURL + "FinancialWServices/CancelB2bRequest";
    checkIBAN = domainURL + "FinancialWServices/checkIBAN/";
    AllTransfersReq = domainURL + "FinancialWServices/GetB2bRequests/";
    GetTransferReqPenddingShares = domainURL + "FinancialWServices/GetTransferReqPenddingShares/";
    GetActiveIPOList = domainURL + "FinancialWServices/GetActiveIPOList";
    GetIPOCategories = domainURL + "FinancialWServices/GetIPOCategories";
    GetIPOApplicationList = domainURL + "FinancialWServices/GetIPOApplicationList";
    GetIPOBalanceAndNotes = domainURL + "FinancialWServices/GetIPOBalanceAndNotes";
    FindIPOCharacteristics = domainURL + "KYCWServices/FindIPOCharacteristics";
    ValidationAndAmountCalculation = domainURL + "KYCWServices/validationAndAmountCalculation";
    CreateIpoApplication  = domainURL + "KYCWServices/create";

    getAllPushNotificationsByUser = domainURL + "NotificationWServices/GetAllPushNotificationsByUser/";
    getAllPushNotificationsFromFirebase = domainURL + "NotificationWServices/GetAdminNotification/";
    updateReadPushNotificationsFlag = domainURL + "NotificationWServices/UpdateReadPushNotificationsFlag/";
    // getHistorySymbolData = domainURL + "NotificationWServices/GetHistorySymbolData/";
    getHistorySymbolData = domainURL + "NotificationWServices/GetDailySymbolCharts/";
    getAlerts = domainURL + "NotificationWServices/GetAlertByUSerCode/";
    addAlert = domainURL + "NotificationWServices/AddAlert/";
    deleteAlertByAlertID = domainURL + "NotificationWServices/DeleteAlertByAlertID/";
    getConditionalByUsr = domainURL + "NotificationWServices/GetConditionalByUsr/";
    deleteConditionalByID = domainURL + "NotificationWServices/DeleteConditionalByID/";
    addConditionalOrder = domainURL + "NotificationWServices/AddConditionalOrder";
    getDFN_StockData = domainURL + "RealTimeWServices/GetDFN_StockData";
    getLastChatConversion = domainURL + "NotificationWServices/GetLastChatConversion/";
    getChatWebBRKLookup = domainURL + "NotificationWServices/GetChatWebBRKLookup/";
    GetShareTransferLogGrouped = domainURL + "FinancialWServices/GetShareTransferLogGrouped/";
    GetShareTransferLogWithDetails = domainURL + "FinancialWServices/GetShareTransferLogWithDetails/";
    GetShareTransferLogDetails = domainURL + "FinancialWServices/GetShareTransferLog/";
    GetNextRequestID = domainURL + "FinancialWServices/GetNextRequestID/";
    SubmitShareTransferReq = domainURL + "FinancialWServices/SubmitShareTransferReq";
    SubmitMCDShareTransfer = domainURL + "FinancialWServices/SubmitMCDShareTransfer";
    EstimateOrderCharges = domainURL + "TradingWServices/EstimateOrderCharges";
    SubmitMCDCashTransfer = domainURL + "FinancialWServices/SubmitMCDCashTransfer";
    GetMCDShareTransferList  = domainURL + "FinancialWServices/GetMCDShareTransferList ";
    SubmitEquityTransferReq = domainURL + "FinancialWServices/SubmitEquityTransferReq";
    AddEquityTrans = domainURL + "FinancialWServices/AddEquityTrans";
    GetAccountTransferInfo = domainURL + "FinancialWServices/GetAccountTransferInfo";
    GetExpectedProfitLossSec = domainURL + "FinancialWServices/GetExpectedProfitLossSec/";

    GetAccountSummaryReport = domainURL + "ReportGeneratorWServices/GetAccountSummaryReport";
    GetExpectedPortfolioReport = domainURL + "ReportGeneratorWServices/GetExpectedPortfolioReport";
    GetProfitLossTransactionReport = domainURL + "ReportGeneratorWServices/GetProfitLossTransactionReport";
    GetTradesConfirmationReport = domainURL + "ReportGeneratorWServices/GetTradesConfirmationReport";
    GetUSCompaniesResults = domainURL + "RealTimeWServices/GetUSCompaniesResults/";
    GetUSSymbolNews = domainURL + "RealTimeWServices/GetUSSymbolNews/";


    GetHoldingStatementReport = domainURL + "FinancialWServices/GetHoldingStatementReport";
    DownloadHoldingStatement = domainURL + "FinancialWServices/DownloadHoldingStatement";

    GetCryptoCompaniesResults = domainURL + "RealTimeWServices/GetCryptoCompaniesLookup/";

    GetContactInfo = domainURL + "GeneralWServices/GetContactInfo";
    GetCashDepURL = domainURL + "GeneralWServices/GetCashDepURL/";
    GetDeviceConfigs = domainURL + "GeneralWServices/GetDeviceConfigs";
    getEGYPTSectors = domainURL + "GeneralWServices/GetSectors";

    TechnicalIndicator = domainURL + "RealTimeWServices/TechnicalIndicator";
    CustodiansByClientID = domainURL + "TradingWServices/GetCustodiansByClientID";
    BasketOrederURL = domainURL + "TradingWServices/GetBasketOrderDetails";
    DeleteBasketOrder = domainURL + "TradingWServices/DeleteBasketOrderDetails";
    UpdateRejectReasonBasketOrder = domainURL + "TradingWServices/UpdateRejectReasonBasketOrder";
    GetDailyReports = domainURL + 'GeneralWServices/GetDailyReports';
    TransferAmount = domainURL + 'FinancialWServices/CrmRequest';
    GetIPOLink = domainURL + "GeneralWServices/GetIPOLink/";
    UpdateTermsAndConditionsVersion = domainURL + "GeneralWServices/UpdateTermsAndConditionsVersion/";
    GetTermsAndConditionsText = domainURL + "GeneralWServices/GetTermsAndConditionsText/";
    GetHistoryOrders = domainURL + "GeneralWServices/GetHistoryOrders/";
    GetHistoricalTradesList = domainURL + "TradingWServices/GetTrades/";
    GetChartIntraDayData = serverURL + "RealTimeWServices/GetChartIntraDayData/"; //mustafa
    GetSubscriptionPlans = domainURL + "FinancialWServices/GetSubscriptionPlans";//mustafa
    GetSubscribedPlans = domainURL + "FinancialWServices/GetSubscribedPlans";//mustafa
    AddSubscription = domainURL + "FinancialWServices/AddSubscription";//mustafa
    GetCurrencyConversion = domainURL + "FinancialWServices/GetCurrencyConversion";//mustafa


    GetSymbolsTrades = domainURL + "TradingWServices/GetSymbolTrades/";
    GetBracketOrder = domainURL + "TradingWServices/GetBracketOrder/";
    CashTransfer = domainURL + "FinancialWServices/CashTransfer";
    GetMCDCashTransfer = domainURL + "FinancialWServices/GetMCDCashTransfer";
    GetMarketWatchBySectorID = domainURL + "MarektWServices/GetMarketWatchBySectorID";


    GetMarketPerformanceData = domainURL + "TradingWServices/GetMarketPerformanceData/";
    GetMDBlockTrade = domainURL + "TradingWServices/GetMDBlockTrade/";
    GetMDSectorRanking = domainURL + "TradingWServices/GetMDSectorRanking/";
    GetMDMarketBreadth = domainURL + "TradingWServices/GetMDMarketBreadth/";
    GetMDInvestorsDistribution = domainURL + "TradingWServices/GetMDInvestorsDistribution/";
    GetMDInvestorsDistributionDataChart = domainURL + "TradingWServices/GetMDInvestorsDistributionDataChart/";
    SendCallBankTransfareRequest = domainURL + 'TradingWServices/SendCallBankTransfareRequest';
    GetNewCustodiansByClientID = domainURL + "TradingWServices/GetCustodianByClientID";
    GetTradeSummary = domainURL + "TradingWServices/GetTradeSummary/";
    GetTodayTrade = domainURL + "TradingWServices/GetTodayTrade";

    MainCrmRequest = domainURL + 'GeneralWServices/MainCrmRequest';
    // KYC services
    GetCountriesLookup = domainURL + "KYCWServices/GetCountries";
    GetOnboardingLookUP = domainURL + "KYCWServices/GetOnboardingLookUP";
    GetNationalityLookup = domainURL + "KYCWServices/Getnationality";
    GetBankAccDetails = domainURL + "KYCWServices/GetBankAccDetails";
    AMLSib = domainURL + "KYCWServices/AMLSib";
    CreateADXNin = domainURL + "KYCWServices/CreateADXNin";
    CreateDFMNin = domainURL + "KYCWServices/CreateDFMNin";
    OTPSend = domainURL + "KYCWServices/OTPSend";
    LoginByUsrKYC = domainURL + "KYCWServices/LoginByUsrKYC";
    GetOnboardingData = domainURL + "KYCWServices/GetOnboardingData";
    GetSourceOfIncome = domainURL + "KYCWServices/GetSourceOfIncome";
    GetAnnualIncome = domainURL + "KYCWServices/GetAnnualIncome";
    GetInvesObjective = domainURL + "KYCWServices/GetInvesObjective";
    GetRiskClassification = domainURL + "KYCWServices/GetRiskClassification";
    GetCities = domainURL + "KYCWServices/GetCities";
    GetKYCCibc = domainURL + "KYCWServices/GetKYCCibc";
    GetCompaniesKYC = domainURL + "KYCWServices/GetCompanies";
    InsertAttachments = domainURL + "KYCWServices/InsertAttachments";
}

/* Orders */
export let config = {
    RealTimeOrders: true,
    AllowOfflineOrder: true,
    CompanyName: "RAMZ",
    RememberUserName: true,
    RememberPassword: true,
};

/* End Orders */
export let OrderStatusText = {
    Active: "Active",
    Traded: "Traded",
    Canceled: "Canceled",
    Suspended: "Suspended",
    Expired: "Expired",
    Pending: "Pending",
    New: "New",
    Outstanding: "Outstanding",
    Partially_Filled: "Partially Filled",
    Rejected: "Rejected",
    Fully_Filled: "Fully Filled",
    Sent: "Sent",
    Waiting: "Waiting",
    Private_Order: "Private Order",
    Unplaced_Order: "Unplaced Order",
    Pending_Modify: "Pending Modify", //1s
    Pending_New: "Pending New", //1s
    Pending_Canceld: "Pending Canceld", //1s
    InActive_Trigger: "InActive Trigger", //1s
    TriggerOrder: "Trigger Order",
    Monitoring: "Monitoring",
    InactiveTrigger: "Pending Trigger"
};
export let OrderStatusTextArabic = {
    Active: "فعال",
    Traded: "Traded",
    Canceled: "ملغى",
    Suspended: "Suspended",
    Expired: "انتهت صلاحيته",
    Pending: "قيد التنفيذ",
    New: "جديد",
    Outstanding: "Outstanding",
    Partially_Filled: "منفذ جزئي",
    Rejected: "مرفوض",
    Fully_Filled: "منفذ بالكامل",
    Sent: "مرسل",
    Waiting: "انتظار",
    Private_Order: "Private Order",
    Unplaced_Order: "Unplaced Order",
    Pending_Modify: "Pending Modify", //1s
    Pending_New: "Pending New", //1s
    Pending_Canceld: "Pending Canceld", //1s
    InActive_Trigger:  "بانتظار التفعيل", 
    TriggerOrder: "Trigger Order",
    Monitoring: "Monitoring",
    InactiveTrigger: "بانتظار التفعيل"
};
export let OrderStatusResponse = {
    Active: "A",
    //Traded: 'T',// P or S partialy or fully filled
    Canceled: "C",
    Suspended: "D",
    Expired: "E",
    Pending: "I",
    New: "N",
    //Outstanding: 'O',
    Partially_Filled: "P",
    Rejected: "R",
    Fully_Filled: "S",
    Sent: "T", // T
    Waiting: "W",
    Private_Order: "Z",
    Unplaced_Order: "L",
    Pending_Canceld: "H", //1s
    Pending_New: "F", //1s
    Pending_Modify: "G", //1s
    InActive_Trigger: "X", //1s
    Resumed: "U", //1s 
    TriggerOrder: "V",
    Monitoring: "M",
    InactiveTrigger: "X",
};
export let OrderCategory = {
    Normal: "0",
    Basket: "1",
    ProRata: "2",
    TargetOrder: "3",
    Algo: "4",
    OPR: "5",
    CareOrder: "6",
    BasketTemplate: "7",
    SubProRata: "8",
    CrossOrder: "9",
    AON: "10",
    SmartOrder: "11",
    StopLoss: "12",
    TakeProfit: "13",
    Conditional: "14"
};
export let OrderValidityResponse = {
    Day: "0001",
    GTC: "0002",
    GTD: "0003",
    GTW: "0004",
    GTM: "0005",
    FOK: "0006",
    FAK: "0007",
};

export let CriteriaConditionalOrders = {
    Equals: "0",
    GreaterThan: "1",
    LessThan: "2"
};
export let ParametersConditionalOrders = {
    LastPrice: "1",
    HighPrice: "2",
    LowPrice: "3",
    BidPrice: "4",
    OfferPrice: "5",
    NeChange: "6",
    NetChangePerc: "7",
    AveragePrice: "8",
    TotalValue: "9",
    TotalVolume: "10"
}

export let account = {
    ALLOW_DERIV_TRADING: "",
    AccType: "",
    AccountDesc: "",
    AccountID: "",
    CL_BANK_ID: "",
    CL_BANK_ID2: "",
    CUR_CODE: "",
    ClientID: "",
    ClientNameA: "",
    ClientNameE: "",
    Email_Address: "",
    Exchange: "",
    Exchange_DESC_A: "",
    Exchange_DESC_E: "",
    IS_DEFAULT_ACC: "",
    IS_INTER: "",
    IS_Islamic: "",
    IS_MARGIN_ACC: "",
    IS_SAMEDAY: "",
    MainClientID: "",
    MainClientNameA: "",
    MainClientNameE: "",
    Mobile_NO: "",
    NIN: "",
};

export let Layouts = {
    Trading: 1,
    Market_Overview: 2,
    Account_Summary: 3,
    New_Workspace: 4,
    fit_ag_grid: 5,
    Advance_Chart: 6,
    Stock_Profile: 7,
    settings: 999,
    defaultWorkspace: 8,
    binanceWorkspace: 9
};

export let DockingTabs = {

    Main_Grid: "t01",
    Order_List: "t02",
    Order_Basket: "t10",
    Orders_Entry: "t11",
    Order_Search: "t12",
    Information: "t13",
    Market_Time_And_Sales: "t14",
    Tops: "t15",
    News_And_Announcements: "t16",
    Transfers: "t17",
    Account_Summary: "t18",
    Portfolio: "t19",
    Statement: "t20",
    Chart: "t21",
    Trade_Confirmation: "t22",
    Market_Indicies: "t23",
    Conditional_Orders: "t24",
    Balance_Breakdown: "t25",
    Historical_Symbol: "t26",
    Alert_Manager: "t27",
    Fundamental_Data: "t28",
    Client_Information: "t29",
    Market_Depth: "p30",
    Stock_Details: "p31",
    ChartIQ: "p32",
    SymbolTimeAndSales: "p34",
    SymbolNewAndAnnouncements: "p35",
    DetailQuote: "p36",
    TopsActive: "p37",
    Sector_overview: "p38",
    MarketSummary: "p39",
    AccountSummaryChart: "p40",
    HoldingsAllocation: "p41",
    TransactionSummary: "p42",
    ShortMWSymbol: "p43",
    VerticalMarketDepth: "p44",
    EquityTransfer: "p45",
    AllTransfersScreen: "p46",
    BinanceOrderEntry: "p47",
    AnalysisIndecator: "p48",
    BasketOrders: "p49",
    DailyReports: "p50",
    Requests: "p51",

    PortfolioFromDB: "p52",
    CopyPeopleList: "p54",
    TopTradersPortfolio: "p55",
    ChartTradeMarkets: "p56",
    MarginSharesList: "p57",
    cashFlowStatements: "p58",
    SymbolsTrades: "p59",
    BracketOrder: "p60",
    CashTransfer: "p61",
    TransferBetween: "p62",

    MarketPerformance: "p63",
    InvestorDashboard: "p64",
    MarketBreadthDashboard: "p65",
    SectorRankingDashboard: "p66",
    BlockTrades: "p67",
    Combinecomponents: "p68",
    TransferRequest: "p69",
    CrmRequestSIB: "p70",
    ShareINOman: "p71",
    CashOutOman: "p72",
    TradeSummary: "p73",
    HistoricalOrders: "p74",
    TodayTrades: "p75",
    ShareTransfer: "p76",
    Orders_Entry_Advanced: "p77",
    HistoricalTradesList: "p78",
    EquityTransferQSC: "p79",
    IPOSubscription: "p80",




};

//Id tab include linking Color button:
export let linkingColorTabs =
    "t01, t02 , t11 , t12 , t26, t27 , t28 , p30, p31 , p32 , p34 , p35 , p36 , p77,p71";

export let LoginStatus = {
    Success: "0", //Sucess login
    InvalidLogin: "-1", //Invalid login
    invalidTokenID: "-2", //Invalid TokenID
    TokenSent: "-3", //OTP Token Sent
    TokenExpire: "-4", //Token is Expired
    noPermetions: "N", //No Permissions
    ExceedNoTrials: "-6", //Exceed No of Trials
    AlreadyLoggedIn: "-7", //Already logged in
    NotAgreeTermCondtion: "-8", //Didn't agree to terms and conditions
    UnknowError: "-10", //Unknow Error
    IPOQuickSell: "-11", //IPO Quick sell Acount_Not_EXIST OR More_Then_One_User
    EnableEtrade: "-22",
    NotificationsSentToMobile: "-25" ,//VASCO_Notifications_Enabled sent Notifications to mobile
    NotificationsSentToMobileFCM: "-28" ,//FCM_Notifications_Enabled sent Notifications to mobile
     CaptchaRequired: "-29"
};

export let ComponentChildCode = {
    Market_Watch: "1",
    Market_Watch_Trade: "49",
    Order_List: "13",
    Order_List_1: "164",
    Sell_Orders_Entry: "11",
    Buy_Orders_Entry: "12",
    Shares_Transfer: "377",

    TransferParent: "34",
    Transfer: "370",
    Internal_Transfer: "382",
    Wire_Transfer: "384",
    Cheque_Transfer: "383",
    IBAN_Transfer: "385",
    Cancel_Transfer: "374",
    Request_Log: "386",
    BankIS: "387",

    Account_Summary: "44",
    Account_Statement: "46", //=> Component: Statment
    Live_Chart: "24", //=> Component: Chart
    Trade_Confirmation: "78", //=> Component: Trade Confirmation
    Balance_Breakdown: "76",
    Historical_Symbol_Meta_Data: "83", //=>Component: Historical Symbol
    Alert: "21",
    Client_Informations: "77",
    Market_Depth: "85",
    Market_Depth_Order: "3",
    Market_Depth_price: "2",

    Martet_By_Symbol: "4",
    Conditional_Orders: "35",
    Fundamental_Data: "96",
    ChartIQ: "10",
    Portfolio: "20",
    Stock_Details: "100",
    Market_Indicies: "22",
    Market_Time_And_Sales: "29",
    Symbol_Time_And_Sales: "103",
    Market_News_And_Announsments: "6",
    Symbol_News_And_Announsments: "97",

    Tops: "16",
    Tops_Gainers: "25",
    Tops_Losers: "26",
    Tops_Value: "27",
    Tops_Volume: "28",
    Top_Trades: "106",

    Order_Search: "13408",
    Order_Basket: "14",
    change_password: "19",
    Quick_Order: "47",
    Market_trade_summary: "30",
    ShortMWSymbol: "104",
    TransactionSummary: "105",

    EtradeTicker: "72",
    ChangePassword: "19",


    // Equity Transfer
    EquityTransfer: "107",
    EquityTransferDisplay: "1",
    EquityTransferIn: "2",
    EquityTransferOut: "3",
    EquityTransferBetween: "4",
    EquityTransferLog: "5",
    EquityTransferCancel: "6",
    // --
    ContactUS: "108",
    UpdateIdValidity: "109",
    cashDeposit: "110",
    KYCLink: "111",
    IPOLink: "112",
    PreferredLanguage: "113",
    Subscription: "114",

    //DailyReports
    DailyReports: "115",
    DailyReportsDisplay: "1",
    Highlights: "2",
    EgyptDaily: "3",
    TechnicalReport: "4",
    AuthorityFiles: "5",
    //--



    // Copy People profile screen
    CopyPeopleList: "116",
    TopTradersPortfolio: "117",
    ChartTradeMarkets: "118",
    AboutMyAccount: "119",
    // --



    MarginSharesList: "120",
    cashFlowStatements: "121",
    SymbolsTrades: "122",
    subscriptionPlan: "123",

    CashTransfer: "124",
    MarketPerformance: "125",
    InvestorDashboard: "126",
    MarketBreadthDashboard: "127",
    SectorRankingDashboard: "128",
    BlockTrades: "129",
    Combinecomponents: "130",

    ClientPortal: "131",
    TransferRequest: "132",
    ShareINOman: "133",
    CashOutOman: "134",
    TradeSummary: "135",
    HistoricalOrders: "136",
    TodayTrades: "137",
    internationalAccountKYC: "138",
    HistoricalTradesList: "139",
    PreferredAccount: "140",
    CrmRequest: "141",
    IPOSubscription: "142",


};

export let redirectMobileURLS = {
    IOS: " https://apps.apple.com/us/app/intl-securities/id1048904565",
    Android: "https://play.google.com/store/apps/details?id=app.id_IntegratedS_95149acdecf047db9b60bfc7b84de372",
};

export let dateFormat = "ddMMyyyy";
export let dateFormat_4 = "dd-MM-yyyy";

export let defaultTheme = "light"; //options: dark, light

export let errorNotifyDuration = 2000; //2000;
export let successNotifyDuration = 2000;
